import { Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Config } from 'src/app/models/config.model';
import { ConfigService } from 'src/app/services/config.service';
import { FaqService } from 'src/app/services/faq.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-faq-list',
  templateUrl: './faq-list.component.html',
  styleUrls: ['./faq-list.component.scss']
})
export class FaqListComponent implements OnDestroy {

  private componentDestroyed = new Subject();

  faqQuestions!: any[];
  config!: Config;

  constructor(
    private spinnerService: SpinnerService,
    private faqService: FaqService,
    private configService: ConfigService) {

    this.spinnerService.show('Henter spørsmål og svar...');

    this.configService.config
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (config: Config | null) => {
          if (config !== null) {
            this.config = config;
          }
        }
      )

    this.faqService.faqQuestions
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (items: any[]) => {
          this.faqQuestions = items;
          this.spinnerService.hide();
        }
      );

    this.faqService.readFAQQuestions();
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }


}
